import { createStore } from 'jotai';
import { sizeAtom } from '@components/metrics-panel-hz/atoms';
import { summaryPanelAtom } from '@src/atoms/panels';

function initStore() {
  const store = createStore();
  store.set(sizeAtom, 'l');
  store.set(summaryPanelAtom, false);
  return store;
}

export default initStore;
